import script from "./AvatarMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarMenu.vue?vue&type=script&setup=true&lang=js"

import "./AvatarMenu.vue?vue&type=style&index=0&id=a0f71772&lang=scss"
import "./AvatarMenu.vue?vue&type=style&index=1&id=a0f71772&scoped=true&lang=scss"
import "./AvatarMenu.vue?vue&type=style&index=2&id=a0f71772&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./AvatarMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0f71772"]])

export default __exports__